



















































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
// import TandaVitalInput from "@/components/TandaVitalInput.vue";
import TandaVitalStore from "@/store/modules/TandaVitalStore";
import ReferensiAsesmen from "@/store/modules/new/ReferensiAsesmen";
import { intervensiEwsOptions } from "@/utility/DataReferensi";
import moment from "moment";
import MonitorTandaVitalChart from "@/components/chart/MonitorTandaVitalChart.vue";

@Component({
  components: {
    // TandaVitalInput,
    MonitorTandaVitalChart
  }
})
export default class TandaVitalTable extends Vue {
  @Prop() selectedId;
  @Prop() register;
  @Prop({ default: false, type: Boolean }) showSelect: boolean;
  @Prop({ default: true, type: Boolean }) showActions: boolean;
  @Prop({ default: false, type: Boolean }) showReload: boolean;
  @Prop({ default: false, type: Boolean }) previewMode: boolean;
  @Prop({ default: "asc", type: Boolean }) sort: "asc" | "desc";

  tblHeight = "500";
  defaultHeaders = [
    {
      text: "Waktu Periksa",
      align: "start",
      value: "waktu_periksa",
      width: "130px"
    },
    { text: "Henti Jantung", value: "henti_jantung" },
    { text: "Tekanan Darah (mmHg)", value: "sistole", width: "130px" },
    { text: "MAP", value: "map" },
    { text: "Frek.Nadi (x/menit)", value: "frekuensi_nadi" },
    { text: "Frek.Nafas (x/menit)", value: "frekuensi_nafas" },
    { text: "Suhu Badan (oC)", value: "suhu_badan" },
    { text: "Saturasi O2 (%)", value: "saturasi_oksigen" },
    { text: "Kesadaran", value: "kesadaran", width: "110px" },
    { text: "EWS Skor", value: "ews_skor" },
    { text: "Keadaan Umum", value: "keadaan_umum" },
    { text: "Nyeri", value: "nyeri", width: "100px" },
    { text: "Suplemen O2 (% / lt/menit)", value: "suplemeno2" },
    { text: "GDS (mg/dl)", value: "gds" },
    { text: "Urin output", value: "urin_output" },
    { text: "Sianosis", value: "sianosis" },
    { text: "Retraksi", value: "retraksi" },
    { text: "Kapiler (dtk)", value: "kapiler" },
    { text: "Proteinuria", value: "proteinuria" },
    { text: "Discharge/ Lochea", value: "lochea" },
    { text: "TFU (cm)", value: "tfu" },
    { text: "Unit", value: "unit.nama" },
    { text: "Petugas", value: "user.nama", width: "110px" },
    { text: "Aksi", value: "id" }
  ];
  previewHeaders = [
    {
      text: "Waktu Periksa",
      align: "start",
      value: "waktu_periksa",
      width: "130px"
    },
    { text: "Tekanan Darah (mmHg)", value: "sistole", width: "130px" },
    { text: "Frek.Nadi (x/menit)", value: "frekuensi_nadi" },
    { text: "Frek.Nafas (x/menit)", value: "frekuensi_nafas" },
    { text: "Suhu Badan (oC)", value: "suhu_badan" },
    { text: "Saturasi O2 (%)", value: "saturasi_oksigen" },
    { text: "Kesadaran", value: "kesadaran", width: "110px" },
    { text: "Nyeri", value: "nyeri", width: "100px" },
    { text: "Unit", value: "unit.nama" }
  ];
  sortBy = null;
  sortDesc = false;
  options: {
    page: number;
    itemsPerPage: number;
    sortBy: string[];
    sortDesc: string[];
  } = null;
  idHover = null;

  selectedTtv = [];

  rekomEws = null;
  previewEwsItem = null;
  showRekomEwsDialog = false;

  showTtvGrafik = false;

  get headers() {
    if (this.previewMode) {
      return this.previewHeaders;
    }

    if (!this.showActions) {
      this.defaultHeaders.splice(-1);
    }

    return this.defaultHeaders;
  }

  get chartSeries() {
    const data = this.ttvList
      // .filter(item => item.unit?.id == userModule.user.unit_id)
      .sort((a, b) => {
        return (
          new Date(a.waktu_periksa).getTime() -
          new Date(b.waktu_periksa).getTime()
        );
      })
      .reduce(
        (result, item) => {
          result.suhu.push({
            x: new Date(item.waktu_periksa),
            y: item.suhu_badan
          });

          result.nadi.push({
            x: new Date(item.waktu_periksa),
            y: item.frekuensi_nadi
          });

          result.nafas.push({
            x: new Date(item.waktu_periksa),
            y: item.frekuensi_nafas
          });

          result.map.push({
            x: new Date(item.waktu_periksa),
            y: item.map
          });

          result.tensi.push({
            x: new Date(item.waktu_periksa),
            y: [item.sistole, item.diastole]
          });

          return result;
        },
        { suhu: [], nadi: [], nafas: [], map: [], tensi: [] }
      );

    return [
      {
        name: "tensi",
        type: "candlestick",
        data: data.tensi
      },
      {
        name: "suhu",
        type: "line",
        data: data.suhu
      },
      {
        name: "nadi",
        type: "line",
        data: data.nadi
      },
      {
        name: "nafas",
        type: "line",
        data: data.nafas
      },
      {
        name: "MAP",
        type: "line",
        data: data.map
      }
    ];
  }

  get dataSet() {
    return {
      labels:
        this.chartSeries
          .find(item => item.name == "tensi")
          ?.data.map(item => moment(item.x).format("yyyy-MM-DD HH:mm")) ?? [],
      tensi:
        this.chartSeries
          .find(item => item.name == "tensi")
          ?.data.map(item => item.y) ?? [],
      suhu:
        this.chartSeries
          .find(item => item.name == "suhu")
          ?.data.map(item => item.y) ?? [],
      nadi:
        this.chartSeries
          .find(item => item.name == "nadi")
          ?.data.map(item => item.y) ?? [],
      nafas:
        this.chartSeries
          .find(item => item.name == "nafas")
          ?.data.map(item => item.y) ?? [],
      mapVal:
        this.chartSeries
          .find(item => item.name == "MAP")
          ?.data.map(item => item.y) ?? []
    };
  }

  get chartWide(): number | undefined {
    return this.dataSet.labels.length > 30
      ? this.dataSet.labels.length * 30
      : undefined;
  }

  get chartWideStr(): string | undefined {
    return this.chartWide ? `${this.chartWide.toString()}px` : undefined;
  }

  // HARUSNYA SHOW GRAFIK DI DIALOG GAK PERLU FETCH DATA DARI SERVER TERUS MENERUS!!!!
  @Watch("showTtvGrafik")
  changeShowTtvGrafik(val) {
    if (val) {
      this.$nextTick(() => {
        this.reload();
      });
    }
  }

  @Watch("selectedTtv")
  changedSelectedTtv(val) {
    this.$emit("selectedItem", val);
  }

  @Watch("selectedId")
  changedSelectedId(val) {
    const ids = Array.isArray(val) ? val : [val];
    this.selectedTtv = this.renderedTtvList.filter(item =>
      ids.includes(item.id)
    );
  }

  mounted() {
    this.sortBy = "waktu_periksa";
    this.sortDesc = true;
  }

  get ttvList() {
    return TandaVitalStore.list;
  }

  get totalList() {
    return TandaVitalStore.totalList;
  }

  get renderedTtvList() {
    return this.ttvList.sort((a, b) => {
      return this.sort === "desc"
        ? new Date(b.waktu_periksa).getTime() -
            new Date(a.waktu_periksa).getTime()
        : new Date(a.waktu_periksa).getTime() -
            new Date(b.waktu_periksa).getTime();
    });
  }

  get loadingList() {
    return TandaVitalStore.loading;
  }

  edit(id) {
    this.$emit("edit", id);
  }

  remove(id) {
    this.$emit("remove", id);
  }

  reload() {
    // untuk pagination
    // pagination technically works, but still has issue on calling multiple request
    // const { page, itemsPerPage, sortBy, sortDesc } = this.options;
    // const params = {
    //   page: page,
    //   itemsPerPage: itemsPerPage,
    //   sortBy: sortBy[0],
    //   sortDesc: sortDesc[0],
    //   registerId: this.register
    // };

    TandaVitalStore.getByRegister(this.register).then(() => {
      this.changedSelectedId(this.selectedId);

      document.getElementById(
        "ttv-cart-container"
      ).scrollLeft += this.chartWide;
    });
  }

  parseEwsColor(item) {
    const lvl = item?.ews_level;
    if (lvl === "blue") {
      return "blue";
    } else if (lvl === "rendah") {
      return "yellow";
    } else if (lvl === "sedang") {
      return "orange";
    } else if (lvl === "tinggi") {
      return "red";
    } else {
      return "";
    }
  }

  parseEwsText(item) {
    if (item.henti_jantung === "y") {
      return "Henti Jantung";
    } else if (item.ews_cat) {
      return item.ews_skor;
    } else {
      return "";
    }
  }

  parseTensi(item) {
    if (item.periksa_tensi == 1 || item.periksa_tensi === null) {
      return item.tekanan_darah_text;
    } else {
      if (item.periksa_tensi == 2) {
        return "Tidak terukur";
      } else if (item.periksa_tensi == 0) {
        return "Tidak diperiksa";
      } else {
        return "";
      }
    }
  }

  parseFrekNadi(item) {
    const nadi =
      ReferensiAsesmen.periksaNadi.find(it => it.id === item?.nadi)?.name ??
      null;
    return nadi ? `${nadi}: ${item.frekuensi_nadi}` : item.frekuensi_nadi;
  }

  parseSianosis(item) {
    return (
      ReferensiAsesmen.sianosisCategory.find(it => it.id === item?.sianosis)
        ?.name ?? ""
    );
  }

  parseRetraksi(item) {
    return (
      ReferensiAsesmen.retraksiCategory.find(it => it.id === item?.retraksi)
        ?.name ?? ""
    );
  }

  parseProteinuria(item) {
    return (
      ReferensiAsesmen.proteinuriaCategory.find(
        it => it.id === item?.proteinuria
      )?.name ?? ""
    );
  }

  parseLochea(item) {
    return (
      ReferensiAsesmen.locheaCategory.find(it => it.id === item?.lochea)
        ?.name ?? ""
    );
  }

  copyData(data) {
    this.$emit("copyData", data);
  }

  handleRowHover(item, index) {
    this.idHover = index;
  }

  handleRowLeave(item, index) {
    this.idHover = null;
  }

  parseRekomendasiEWS(item) {
    if (item.ews_cat) {
      this.rekomEws = intervensiEwsOptions.find(it => {
        return item.ews_level == it.level;
      });
    } else {
      this.rekomEws = null;
    }
  }

  showRekomEws(item) {
    this.previewEwsItem = item;
    this.parseRekomendasiEWS(item);
    this.showRekomEwsDialog = true;
  }

  @Watch("showRekomEwsDialog")
  changeShowRekomEwsDialog(val) {
    if (!val) {
      this.rekomEws = null;
      this.previewEwsItem = null;
    }
  }
}
